import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { RoleDAO } from '../../../../core/services/dao/roleDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class EditProfileResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private userDAO: UserDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const sessionResolve = this.authService.checkSession();
    const userResolve = this.userDAO.loadById(route.params.id);
    const mergeResolve = merge(sessionResolve, userResolve);
    return mergeResolve.pipe(
      take(2),
      map((data) => data),
    );
  }
}
